/**
 * CSS Custom Properties
 *
 * These properties can be overridden using the component's tag as selector.
 *
 * @prop --calcite-flow-item-footer-padding: Specifies the padding of the component's footer.
 * @prop --calcite-flow-item-header-border-block-end: Specifies the component header's block end border.
 */

:host {
  @extend %component-host;
  @apply relative flex w-full flex-auto overflow-hidden;
}

@include disabled();

.back-button {
  @apply border-color-3
  border-0
  border-solid;
  border-inline-end-width: theme("borderWidth.DEFAULT");
}

calcite-panel {
  --calcite-panel-footer-padding: var(--calcite-flow-item-footer-padding);
  --calcite-panel-header-border-block-end: var(--calcite-flow-item-header-border-block-end);
}

@include base-component();
